import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';

// Use the eager loading strategy so that we do not create a bunch of extra
// hunks for each of our images which would result in 2x the network requests
const importIcon = (name, path) =>
  import(/* webpackMode: "eager" */ `../../images/${path}/${name}.svg`);

export const Icon = ({ alt, name, path, ...props }) => {
  const [imageSrc, setImageSrc] = useState();

  useEffect(() => {
    importIcon(name, path).then(imageModule => {
      setImageSrc(imageModule.default);
    });
  }, [name]);

  if (!imageSrc) {
    return null;
  }

  return <img alt={alt} className="icon" src={imageSrc} {...props} />;
};

Icon.defaultProps = {
  path: 'icons_v2',
};

Icon.propTypes = {
  alt: propTypes.string,
  name: propTypes.string.isRequired,
  path: propTypes.string,
};
